/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"7\"><path fill=\"#57E07D\" stroke=\"#57E07D\" d=\"M1 3.746l2.664 2.74.5.514.5-.514L10 1.006 9 0 3.664 5.48h1L2 2.74z\"/></svg>\n";
//# sourceMappingURL=check-green.svg.js.map